import { BackgroundColors, BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const ModalBody = styled.div`
	padding: 10px 0 22px 0;
`;

const Box = styled.div`
	padding: 24px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.XL}px;
	margin-bottom: 24px;
`;

const QuestionContainer = styled.div`
	padding: 24px 0;
	border-top: 1px solid ${BorderColors.Secondary};
`;

const QuestionTableWrapper = styled.div`
	height: 88px;
	overflow-y: auto;
	max-width: 640px;
`;

const EndUserComment = styled.div`
	border: 1px solid ${BorderColors.Secondary_primary};
	background-color: ${BackgroundColors.BrandUtility50};
	border-radius: 0 ${BorderRadius.MD}px ${BorderRadius.MD}px ${BorderRadius.MD}px;
	padding: 10px 14px;
	margin-bottom: 24px;
`;

const ProductContainer = styled.div`
	border-top: 1px solid ${BorderColors.Secondary};
	padding-top: 24px;
`;

const ProductWrapper = styled.div`
	padding: 24px;
	border: 1px solid ${BorderColors.Secondary};
	border-radius: ${BorderRadius.XL}px;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
`;

export { ModalBody, Box, QuestionContainer, QuestionTableWrapper, EndUserComment, ProductWrapper, ProductContainer };
